import * as Yup from 'yup';
import {
  cleanPhoneNumber,
  isValidInternationalPhoneNumber,
} from '@rsos/utils/internationalPhoneNumberUtils';

export const initialValues = {
  phoneNumber: '',
};

export const phoneNumberValidator = (
  phoneNumber: string | undefined,
): boolean => {
  if (!phoneNumber) {
    return false;
  }

  const cleaned = cleanPhoneNumber(phoneNumber);

  return isValidInternationalPhoneNumber(cleaned);
};

export const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('Phone number is required')
    .test(
      'isValidPhone',
      'Please enter a valid phone number',
      phoneNumberValidator,
    ),
});
